import React from 'react';
import { Megaphone, Camera } from 'lucide-react';
import SpacedText from '@/components/SpacedText';
import useScrollAnimation from '@/hooks/useScrollAnimation';

const Services = () => {
  const { ref, isVisible } = useScrollAnimation();

  const t = {
    title: 'Our Services',
    description: 'We offer influencer marketing solutions to our corporate clients that elevate the bonds of motherhood and womanhood.',
    service1: 'Influencer Campaign Management',
    service1Desc: 'We identify the most suitable influencers for your goals and budget, manage all communication, and ensure advertising content aligns with your strategy. We deliver your brand\'s message to your target audience with the right communication and present campaign results with transparent reports.',
    service2: 'Content Production & Production',
    service2Desc: 'We shoot and edit high-quality photo and video content that professionally describes your brand\'s products and services for use on your social media accounts with our own expert team.',
  };

  const services = [
    { icon: Megaphone, title: t.service1, desc: t.service1Desc },
    { icon: Camera, title: t.service2, desc: t.service2Desc }
  ];

  return (
    <section 
      ref={ref}
      id="services" 
      className={`py-12 bg-black bg-opacity-75 border-t border-gray-800 scroll-animate ${isVisible ? 'visible' : ''}`}
      data-testid="services-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-6">
          <SpacedText 
            text={t.title} 
            className="text-3xl md:text-4xl text-[#FFDD59] mb-2"
          />
          <p className="text-base md:text-lg text-white leading-relaxed max-w-4xl mx-auto mt-2">
            {t.description}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div 
                key={index}
                className="bg-gray-900 border border-gray-700 rounded-2xl p-6 md:p-8 transition-all duration-300 card-hover-glow hover:border-[#FFDD59]"
                data-testid={`service-card-${index}`}
              >
                <Icon className="mb-4" size={48} color="#FFDD59" />
                <h3 className="text-xl md:text-2xl font-bold text-white mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-300 text-sm leading-relaxed">
                  {service.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
